export default {
    ddsUserRole:"", // operator owner or supplier owner or supplier or owner
    diligenceDetails: null,
    ddsAdditionalInformationData: null,
    diligenceData: null,
    ddsAdditionalInformationByDiligenceId: null,
    isEditModeEnabled: false // Flag to enable editing on readonly reports
}